<template>
  <section class="card tw-px-6 tw-py-4">
    <strong>{{ internalTitle }} ({{ membersCount }})</strong>

    <users-list :users="members" :show-all-link="showAllLink" />
  </section>
</template>

<script>
import UsersList from './users-list'

export default {
  name: 'MemberSidebarItem',
  components: {
    UsersList
  },
  props: {
    showAllLink: String,
    members: Array,
    membersCount: Number,
    title: {
      type: String
    }
  },
  data() {
    return {
      internalTitle: null
    }
  },
  mounted() {
    this.internalTitle = this.title || this.$t('Members')
  }
}
</script>

<style scoped></style>
